import { RuleMessageObjectType, RuleMessageType } from ".";
import { RuleFormType, MessageObjectType } from "../validation/ruleFormSchema";

const defaultMessageObject: MessageObjectType = {
  dynamicEmailMessage: "",
  dynamicMessage: "",
  isDynamicEmailType: false,
  isDynamicMessageType: false,
  isMessageActive: false,
  message: "",
  messageEmail: "",
  messageId: "",
  messageType: RuleMessageType.INTERNAL,
  rulesId: "",
};

export const defaultRuleMessageObject: RuleMessageObjectType = {
  [RuleMessageType.INTERNAL]: {
    ...defaultMessageObject,
    messageType: RuleMessageType.INTERNAL,
    isMessageActive: true,
  },
  [RuleMessageType.EXTERNAL]: {
    ...defaultMessageObject,
    messageType: RuleMessageType.EXTERNAL,
  },
  [RuleMessageType.EMAIL]: {
    ...defaultMessageObject,
    messageType: RuleMessageType.EMAIL,
  },
};

export const defaultRuleObject: RuleFormType = {
  ruleName: "",
  groupName: "",
  priority: -1,
  isActive: false,
  rulesDescription: "",
  rulesTypeId: null,
  routingUserId: null,
  messages: defaultRuleMessageObject,
};
